import { defineQuery, QueryableResults } from "@nova/queryable"

export const missionQuery = defineQuery((missionId: string) => ({
    resource: "missions",
    select: [
        "id",
        "metadata.started_at",
        "metadata.duration",
        "metadata.distance_flown",
        "metadata.avg_altitude",
        "metadata.max_altitude",
        "metadata.avg_speed",
        "metadata.max_speed",
        "metadata.avg_battery_temp",
        "metadata.max_battery_temp",
        "metadata.notes",
        "metadata.location_name",
        "metadata.takeoff_latitude",
        "metadata.takeoff_longitude",
        "metadata.avg_signal_quality",
        "metadata.min_battery_percent",
        "metadata.max_battery_percent",
        "aircraft.id",
        "aircraft.nickname",
        "aircraft.model",
        "user_id",
    ],
    filters: [{ field: "id", op: "=", value: missionId }],
    aggregates: [
        { field: "checklist_links.mission_id", func: "COUNT", alias: "checklistSubmissions" },
    ],
}))

export const tagsQuery = defineQuery(
    (missionId: string) =>
        ({
            resource: "tags",
            select: ["id", "name"],
            filters: [{ field: "mission_links.mission_id", op: "=", value: missionId }],
        }) as const
)

export const missionLogsQuery = defineQuery((missionId: string) => ({
    resource: "logs",
    select: ["timestamp", "altitude", "speed_horizontal", "battery_temp"],
    filters: [{ field: "mission_id", op: "=", value: missionId }],
    orderBy: [{ field: "timestamp", dir: "ASC" as const }],
}))

export type MissionQuerySingleResult = QueryableResults<typeof missionQuery>[number]
export type TagsQueryResult = QueryableResults<typeof tagsQuery>
export type MissionLogsResult = QueryableResults<typeof missionLogsQuery>[number]
